export default __webpack_public_path__ + "locales/az/HotkeysPanel.json?hash=dcbadb57c6aae24ee9c2875a3a8c4473";